export default {
  from: {
    new: 'Новый',
    'delivery-from': 'Доставка от',
  },
  to: {
    delivered: 'Доставлено до',
    deliver: 'Доставить до',
  },
  comment: 'Комментарий водителя',
}
